import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {ThunkAction} from '../../../store/appThunk';
import {getCompanyHost} from '../../../store/data/company/companySelectors';
import {
  closeAccountDetailsAction,
  deleteAccountAndCloseAccountDetailsAction,
  popoutAccountDetailsAction,
} from '../../../store/panels/accounts/accountDetailsPanelActions';
import {AccountDetailsPanelId} from '../../../store/panels/panelStateBase';
import {AccountDetailsPluginHeader} from './accountDetailsPluginHeader';

interface AccountDetailsPluginHeaderContainerProps {
  panelId: AccountDetailsPanelId;
  accountId: number | undefined;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  host: getCompanyHost,
}));

const mapDispatchToProps = makeMapDispatchToProps<AccountDetailsPluginHeaderContainerProps>()((props) => ({
  closeAccountDetails: closeAccountDetailsAction,
  deleteAccountAndCloseAccountDetails: deleteAccountAndCloseAccountDetailsAction,
  openAccountDetailsPopUp:
    (popupWidth: number): ThunkAction =>
    (dispatch) => {
      const {accountId} = props;
      if (!accountId) {
        return;
      }

      dispatch(popoutAccountDetailsAction(props.panelId, accountId, popupWidth));
    },
}));

export const AccountDetailsPluginHeaderContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AccountDetailsPluginHeader);
